import "../../../styles/pages/services/mainservices/FaqHeader.css";


export default function FaqHeader() {
  return (
    <div className="faq-header section-title">
      <h2>Frequently Asked Questions</h2>
      <p>
        Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex
        aliquid fuga eum quidem sint consectetur velit. Quisquam quos quisquam
        cupiditate. Et nemo qui impedit suscipit alias ea.
      </p>
    </div>
  );
}

